<template>
    <v-card flat light color="grey lighten-2" v-if="event !== undefined" class="ma-2">
        <v-card-text v-if="isValid">
            <v-row>
                <v-col sm="2">
                    <v-icon size="90">message</v-icon>
                </v-col>
                <v-col sm="7">
                    <div>Zpráva z: {{ message.createdAt | moment("DD.MM.YYYY HH:mm:ss")}}</div>
                    <v-alert>
                    <div class="font-weight-bold">{{ message.content }}</div>
                    </v-alert>
                    Událost:
                    <div :class="header1Class">{{ event.header1 }}</div>
                    <div :class="header2Class" v-linkified v-html="event.header2"></div>
                    <div :class="header3Class" v-linkified v-html="event.header3"></div>
                </v-col>
                <v-col class="text-xs-center pl-4" sm="3">
                    <v-btn large color="secondary" @click="confirm">Potvrdit přijetí</v-btn>
                    <div class="caption pt-1">Vystaveno upozornění:<br /> {{ message.insertedAt | moment("DD.MM.YYYY HH:mm:ss")}}</div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {SCROLL_TO_MESSAGE_AND_OPEN_CONTEXT, SELECT_EVENT_TAB} from "@/events";
import {appBus} from "@/main";

    export default {
        name: 'event-alert',
        props: {
            notification: {
                type: Object,
            },
        },
        computed: {
            header1Class() {
                return this.event?.header?.title?.class ? this.event.header.title.class : null;
            },
            header2Class() {
                return this.event?.header?.subtitle?.class ? this.event.header.subtitle.class + ' text-truncate' : null;
            },
            header3Class() {
                return this.event?.header?.description?.class ? this.event.header.description.class + ' text-truncate' : null;
            },
            ...mapState({
                message(state) {
                    if (this.notification.entity) {
                        return this.notification.entity;
                    } else {
                        return state.messages.items[this.notification.entityKey];
                    }
                },
                event(state) {
                    console.log(this.message);
                    return state.events.local[this.message.eventUuid];
                },
                eventCategory(state) {
                    return state.eventCategories.items[this.event.eventCategoryId]
                },
            }),
        },
        methods: {
            copyToClipboard(text) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$noty.success("Text zkopírováno do paměti");
                }).catch(error => {
                    this.$noty.error("Chyba při kopírování textu do paměti");
                    console.error("Failed to copy text to clipboard:", error);
                });
            },
            isValid() {
              return this.event.alert && this.event.alert.title;
            },
            ...mapActions('events', [
                'setActiveEvent',
                'save',
            ]),
            async confirm() {
                this.copyToClipboard(this.message.content);
                await this.setActiveEvent(this.event.uuid);
                appBus.$emit(SELECT_EVENT_TAB, `event-messages-${this.message.messageCategoryId}`);

                setTimeout(() => {
                    appBus.$emit(SCROLL_TO_MESSAGE_AND_OPEN_CONTEXT, this.message.id);
                }, 200);

                this.$store.commit('notifications/remove', this.notification.key);
                this.$store.commit('notifications/dialogClose');
            },
        },
        watch: {},
    }
</script>
